import { Grid, Table, TableBody, TableContainer } from '@mui/material';
import { useState } from 'react';
import useApiServices from 'src/api/useApiServices';
import AppContainer from 'src/components/appComponents/AppContainer';
import Scrollbar from 'src/components/scrollbar';
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable,
} from 'src/components/table';
import { ASSETS_API_AI } from 'src/config-global';
import JobStatusTableRow from 'src/sections/AISuggestionsJobStatus/JobStatusTableRow';
import JobStatusTableToolbar from 'src/sections/AISuggestionsJobStatus/JobStatusTableToolbar';
import { AiSuggestion_Job_Status_TABLE_HEAD } from 'src/utils/tables-headers';

export default function AISuggestionJobStatusPage() {
  const table = useTable();
  const { useGetListApi } = useApiServices();
  const [search, setSearch] = useState({ subject: '', status: '' });

  const { data, isLoading } = useGetListApi<any>({
    url: `${ASSETS_API_AI}youtube-search/tasks`,
    parameters: { page: table.page, limit: table.rowsPerPage },
    onSuccess: () => {},
  });

  return (
    <AppContainer
      pageTitle="Job Status"
      routeLinks={[{ name: 'AI Suggestions' }, { name: 'Job Status' }]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <JobStatusTableToolbar search={search} setSearch={setSearch} />
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Scrollbar>
              <Table>
                <TableHeadCustom headLabel={AiSuggestion_Job_Status_TABLE_HEAD} />
                <TableBody>
                  {isLoading
                    ? [...Array(table.rowsPerPage)].map((i, index) => (
                        <TableSkeleton key={index} sx={{ height: 80 }} />
                      ))
                    : data?.data?.data?.tasks?.map((row: any) => (
                        <JobStatusTableRow key={row.id} row={row} />
                      ))}
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>
          {data && (
            <TablePaginationCustom
              count={data?.data?.data?.pagination?.total_count ?? 0}
              page={table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
            />
          )}
        </Grid>
      </Grid>
    </AppContainer>
  );
}
